var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    fillRule: "evenodd",
    d: "M12 .375c2.094 0 4.031.523 5.812 1.57 1.782 1.047 3.196 2.461 4.243 4.243 1.047 1.78 1.57 3.718 1.57 5.812 0 2.094-.523 4.031-1.57 5.813-1.047 1.78-2.461 3.195-4.243 4.242-1.78 1.047-3.718 1.57-5.812 1.57-2.094 0-4.031-.523-5.813-1.57-1.78-1.047-3.195-2.461-4.242-4.242C.898 16.03.375 14.093.375 12c0-2.094.523-4.031 1.57-5.812 1.047-1.782 2.461-3.196 4.242-4.243C7.97.898 9.907.375 12 .375zm0 21.75c1.844 0 3.539-.453 5.086-1.36 1.547-.906 2.773-2.14 3.68-3.702.906-1.563 1.359-3.258 1.359-5.086 0-1.829-.453-3.516-1.36-5.063-.906-1.547-2.14-2.773-3.703-3.68-1.562-.906-3.257-1.359-5.085-1.359-1.829 0-3.516.453-5.063 1.36-1.547.906-2.773 2.14-3.68 3.703-.906 1.562-1.359 3.257-1.359 5.085 0 1.829.453 3.516 1.36 5.063.906 1.547 2.14 2.773 3.702 3.68 1.563.906 3.25 1.359 5.063 1.359zm-1.828-4.5c-.094.125-.219.188-.375.188s-.297-.063-.422-.188l-4.031-4.078c-.094-.094-.14-.219-.14-.375s.046-.297.14-.422l.422-.375c.093-.094.218-.14.375-.14.156 0 .296.046.421.14l3.235 3.281 7.64-7.64c.125-.094.266-.141.422-.141.157 0 .282.063.375.188l.422.375c.094.125.14.265.14.421 0 .157-.046.282-.14.375l-8.484 8.391z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.7c3d96141ca0b0dd369126f85db40048.svg";
export { ForwardRef as ReactComponent };